import { createI18n } from 'vue-i18n'

import en from './en.json'
import de from './de.json'
import fr from './fr.json'
import it from './it.json'

export const defaultLocale = 'de'

export const languages = {
    en: en,
    de: de,
    fr: fr,
    it: it
}

export const messages = Object.assign(languages)


export const i18n = createI18n({
    locale: defaultLocale, // set locale
    fallbackLocale: 'en', // set fallback locale
    messages
})
